import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import * as styles from "../../StudentLogin.module.css";

const OtpCodeStep = ({
  hint,
  otp,
  onOtpChange,
  onVerify,
  onResend,
  verifying,
  busy,
  remaining,
  mustResend,
  error,
}) => (
  <div className={styles.panel}>
    <div className={styles.panelHint}>{hint}</div>
    <InputText
      className={styles.panelInput}
      type="text"
      inputMode="numeric"
      maxLength={6}
      value={otp}
      onChange={(e) => onOtpChange(e.target.value.replace(/[^0-9]/g, ""))}
      placeholder="123456"
      onKeyDown={(e) =>
        e.key === "Enter" && otp.length >= 4 && !mustResend && onVerify()
      }
    />
    <Button
      label="Verify"
      className={styles.panelBtn}
      onClick={onVerify}
      disabled={busy || otp.length < 4 || mustResend}
      loading={verifying}
    />
    <div className={styles.resendRow}>
      <span className={styles.timerText}>Expires in: {remaining}s</span>
      <a
        className={styles.resendLink}
        onClick={!busy && (remaining === 0 || mustResend) ? onResend : undefined}
        style={{
          cursor:
            !busy && (remaining === 0 || mustResend) ? "pointer" : "not-allowed",
          opacity: !busy && (remaining === 0 || mustResend) ? 1 : 0.5,
        }}
      >
        Resend
      </a>
    </div>
    {error && <div className={styles.errorText}>{error}</div>}
  </div>
);

export default OtpCodeStep;
